export const LOGIN_MODES = {
  EMAIL: 0,
  EMAILWITHOTP: 1,
  FORGOT_PASSWORD: 2
};

export const VALIDATION_RULES = {
  EMAIL_REGEX: /\S+@\S+\.\S+/,
  PHONE_REGEX: /^\+?[\d\s-()]+$/,
  MIN_PASSWORD_LENGTH: 6,
  OTP_LENGTH: 6
};

export const ERROR_MESSAGES = {
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid email',
  PASSWORD_REQUIRED: 'Password is required',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters',
  PHONE_REQUIRED: 'Phone number is required',
  PHONE_INVALID: 'Please enter a valid phone number',
  OTP_REQUIRED: 'OTP is required',
  OTP_INVALID: 'OTP must be 6 digits',
  RESET_EMAIL_REQUIRED: 'Email is required',
  RESET_EMAIL_INVALID: 'Please enter a valid email'
};

export const API_ENDPOINTS = {
  LOGIN: '/api/auth/login',
  SEND_OTP: '/api/auth/send-otp',
  VERIFY_OTP: '/api/auth/verify-otp',
  FORGOT_PASSWORD: '/api/auth/forgot-password'
};